import {
  HeroSection,
  WelcomeSection,
  AboutSection,
  ServicesSection,
  CTASection,
  NewsletterSection,
  FAQSection,
  TestimonialsSection,
} from '@/components/sections'
import { NewsletterPopup } from '@/components/common/NewsletterPopup'

export const HomePage = () => (
  <>
    <HeroSection />
    <WelcomeSection />
    <AboutSection />
    <TestimonialsSection />
    <ServicesSection />
    <CTASection />
    <NewsletterSection />
    <FAQSection />
    <NewsletterPopup />
  </>
)
